/** Tab-Filter der Buchungsübersicht – spiegelt URL-Parameter `status`. */
export type BookingListStatusTab =
  | "all"
  | "requested"
  | "rejected"
  | "confirmed"
  | "checked_out";

const CONFIRMED_TAB_STATUSES = new Set(["confirmed", "reserved", "checked_in"]);

export function bookingListStatusTab(status: string): BookingListStatusTab {
  if (status === "requested") return "requested";
  if (status === "rejected") return "rejected";
  if (status === "checked_out") return "checked_out";
  if (CONFIRMED_TAB_STATUSES.has(status)) return "confirmed";
  return "all";
}

export function bookingsListApiUrl(statusFilter: BookingListStatusTab): string {
  if (statusFilter === "confirmed") {
    return "/api/v1/bookings?status=confirmed";
  }
  if (statusFilter === "checked_out") {
    return "/api/v1/bookings?status=checked_out";
  }
  if (statusFilter === "rejected") {
    return "/api/v1/bookings?status=rejected";
  }
  return "/api/v1/bookings";
}

export function buildBookingsOpenUrl(bookingId: string, status?: string): string {
  const params = new URLSearchParams({
    open: bookingId,
    status: status ? bookingListStatusTab(status) : "all",
  });
  return `/bookings?${params.toString()}`;
}
